import { render } from "./FooterNav.vue?vue&type=template&id=1f377bef&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"

import "./FooterNav.vue?vue&type=style&index=0&id=1f377bef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f377bef"

export default script